"use client"

import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

function Toaster({ ...props }: ToasterProps) {
    return (
        <Sonner
            theme="light"
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast:
                        "group toast group-[.toaster]:bg-[var(--bg-surface)] group-[.toaster]:text-[var(--text-primary)] group-[.toaster]:border-[var(--border-subtle)] group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
                    description: "group-[.toast]:text-[var(--text-secondary)]",
                    actionButton:
                        "group-[.toast]:bg-[var(--bg-brand)] group-[.toast]:text-white",
                    cancelButton:
                        "group-[.toast]:bg-[var(--bg-subtle)] group-[.toast]:text-[var(--text-secondary)]",
                    success: "group-[.toaster]:border-[var(--success-200)] group-[.toaster]:bg-[var(--bg-success-subtle)]",
                    error: "group-[.toaster]:border-[var(--danger-200)] group-[.toaster]:bg-[var(--bg-danger-subtle)]",
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
